import React, { FC } from 'react';

import { Grid } from '@material-ui/core';

import { IAdminEvent } from '../../../../store/admin/events/store';

import EventAdminCard from '../../../../components/EventAdminCard/EventAdminCard';
import { getOverviewEvents, IOverview } from './Utils/getOverviewEvents';

interface IProps {
  events: IAdminEvent[];
}

const OverviewEvents: FC<IProps> = props => {
  const { events } = props;

  return (
    <Grid className="grid" container={true} spacing={8}>
      {getOverviewEvents(events).map(({ eventLabel, event }: IOverview) => (
        <Grid key={event.id} className="grid-item" item={true} xs={12} md={4}>
          <EventAdminCard event={event} eventLabel={eventLabel} />
        </Grid>
      ))}
    </Grid>
  );
};

export default OverviewEvents;
